<template>
  <input :type="inputType"
         readonly
         :class="classStyle"
         @click="btnClick($event)"
         :disabled="classStyle==='disabled-btn'"
         :value="text">
</template>
<script>
  export default {
    props: {
      text: {
        type: [String, Number],
        default: '一颗小按钮'
      },
      inputType: {
        type: [String],
        default: 'button'
      },
      classStyle: {
        type: String,
        default: 'default-btn'
      }
    },
    methods: {
      btnClick (event) {
        this.$emit('btnClick', event)
      }
    }
  }
</script>
<style lang="stylus" scoped>
@import '../common/stylus/common'
  input {
    display: inline-block;
    cursor: pointer;
    text-align: center;
    
  }

  /*灰色的按钮*/
  .gray-btn {
    border: 1px solid #d5d5d5;
    color: #646464;
  }
  // 默认按钮
  .default-btn {
    width: 100px;
    height: 30px;
    line-height: 28px;
    vertical-align: middle;
    background-image: -webkit-linear-gradient(top, $fff, #f9f9f9);
    background-image: linear-gradient(180deg, $fff, #f9f9f9);
    color: #646464;
    background-color:#f9f9f9;
    border: 1px solid #e1e1e1;
    border-radius:4px;
    &:hover {
      background-color: #eee;
      background-image: -webkit-linear-gradient(top, #f5f5f5, #eee);
      background-image: linear-gradient(180deg, #f5f5f5, #eee);
    }
  }

  // 主色按钮
  .main-btn {
    width: 100px;
    height: 30px;
    line-height: 28px;
    vertical-align: middle;
    background-image: -webkit-linear-gradient(top, #678ee7, #5078df);
    background-image: linear-gradient(180deg, #678ee7, #5078df);
    border: 1px solid #5c81e3;
    color: #fff;
    border-radius:4px;
    &:hover {
      background-color: #6c8cd4;
      background-image: -webkit-linear-gradient(top, #6c8cd4, #4769c2);
      background-image: linear-gradient(180deg, #6c8cd4, #4769c2);
    }
  }

  // 禁用
  .disabled-btn {
    cursor: not-allowed;
    border: 1px solid #afafaf;
    font-size: 12px;
    color: #fff;
    width: 100px;
    height: 30px;
    line-height: 28px;
    vertical-align: middle;
    background-image: -webkit-linear-gradient(top, #b8b8b8, #a9a9a9);
    background-image: linear-gradient(180deg, #b8b8b8, #a9a9a9);
    border-radius:4px;
  }
  

</style>



// WEBPACK FOOTER //
// yButton.vue?7c240888